import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import IntervalSelector from "../IntervalSelector";
import { NEW_API_URL } from "../../constants/Globals";
import TableBox from "../TableBox";
import ReactPaginate from "react-paginate";
import { Dropdown, DropdownButton } from "react-bootstrap";

function TagsOverview({ selNetworkId }) {
  const [intervalDates, setIntervalDates] = useState({
    start: moment().subtract(30, "days"),
    end: moment(),
  });
  const [prevIntervalDates, setPrevIntervalDates] = useState({
    start: moment().subtract(60, "days"),
    end: moment().subtract(31, "days"),
  });
  const [insightData, setInsightData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [filterType, setFilterType] = useState("All");
  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    fetchTags();
  }, [intervalDates, prevIntervalDates, selNetworkId, currentPage, filterType]);

  const fetchTags = async () => {
    const clientId = selNetworkId ? selNetworkId : "";

    if (!clientId) {
      return;
    }

    const payload = {
      clientId,
      startDate: intervalDates.start.format("YYYY-MM-DD"),
      endDate: intervalDates.end.format("YYYY-MM-DD"),
      prevStartDate: prevIntervalDates.start.format("YYYY-MM-DD"),
      prevEndDate: prevIntervalDates.end.format("YYYY-MM-DD"),
      pageNumber: currentPage,
      pageSize: pageSize,
      filterType: filterType,
    };

    const { data } = await axios.post(`${NEW_API_URL}/insight/tags`, payload);
    if (data.status === 1) {
      setInsightData(data.data.rows || []);
      setTotal(Number(data.data.total));
      setCurrentPage(Number(data.data.currentPage));
      setTotalPages(Number(data.data.totalPages));
      setTotalUsers(Number(data.data.totalUsers));
    }
  };

  const slugify = (name) =>
    name
      .toLowerCase()
      .replace(/ %/, "Percent")
      .replace(/ /g, "")
      .replace(/[^a-zA-Z0-9]/g, "");

  return (
    <>
      <div className="page-headline is-flex">
        <div>
          <strong>Audience</strong>&nbsp;|&nbsp;Tags
        </div>
        <IntervalSelector
          startDate={intervalDates.start}
          endDate={intervalDates.end}
          onChange={(startDate, endDate) => {
            setIntervalDates({ start: startDate, end: endDate });
            setPrevIntervalDates({
              start: moment(startDate).subtract(endDate.diff(startDate), "ms"),
              end: moment(startDate).subtract(1, "days"),
            });
          }}
        />
      </div>

      <div className="standard-dropdown mb-4 d-flex align-items-center gap-2">
        <div className="standard-dropdown-label">Filter by Type:</div>
        <DropdownButton
          title={filterType}
          onSelect={(selectedKey) => {
            setFilterType(selectedKey);
            setCurrentPage(1); // Reset pagination
          }}
          variant="secondary"
        >
          <Dropdown.Item eventKey="All">All</Dropdown.Item>
          <Dropdown.Item eventKey="Interests">Interests</Dropdown.Item>
          <Dropdown.Item eventKey="Intent">Intent</Dropdown.Item>
          <Dropdown.Item eventKey="Emotions">Emotions</Dropdown.Item>
          <Dropdown.Item eventKey="Topic">Topic</Dropdown.Item>
          <Dropdown.Item eventKey="Stance Type">Stance Type</Dropdown.Item>
          <Dropdown.Item eventKey="Emotional Valence">Emotional Valence</Dropdown.Item>
          <Dropdown.Item eventKey="Identity">Identity</Dropdown.Item>
          <Dropdown.Item eventKey="Lifestyle">Lifestyle</Dropdown.Item>
          <Dropdown.Item eventKey="Detail">Detail</Dropdown.Item>
        </DropdownButton>
      </div>
      <TableBox
        name="insightTags"
        count={total}
        tableData={insightData}
        sortByColumn={null}
        sortDirection={null}
        onLoadMore={() => setCurrentPage(currentPage + 1)}
        columnTypes={["Tag", "Type", "Users", "Audience %", "Change %"]}
        slugify={slugify}
        tableRowsTotal={{ users: totalUsers }}
        headerRequired={false}
        cellTag={(row, key) => {
          if (key === "Change %") {
            const value = row.changePercent;
            if (value > 0)
              return <span style={{ color: "green" }}>+{value}%</span>;
            if (value < 0)
              return <span style={{ color: "red" }}>{value}%</span>;
            return <span>{value}%</span>;
          }
          if (key === "Audience %") {
            return <span>{row.audiencePercent}%</span>;
          }
          return (
            row[key.toLowerCase().replace(/ %/, "Percent").replace(/ /g, "")] ||
            row[key.toLowerCase()]
          );
        }}
      />
      {total > 0 && (
        <div className="table-pagination">
          {(currentPage - 1) * pageSize + 1} -{" "}
          {currentPage * pageSize > total ? total : currentPage * pageSize} of{" "}
          {total}
        </div>
      )}
      {total > pageSize && (
        <ReactPaginate
          className="pagination mt-4"
          previousLabel="&laquo;"
          nextLabel="&raquo;"
          breakLabel="..."
          breakClassName="break-me"
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(data) => setCurrentPage(data.selected + 1)}
          containerClassName="pagination"
          activeClassName="active"
          forcePage={currentPage - 1}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(TagsOverview);
